/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Hook_HeadingInputs */

const en_onboarding_v1_hook_heading = /** @type {(inputs: Onboarding_V1_Hook_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grow your money on autopilot.`)
};

const de_onboarding_v1_hook_heading = /** @type {(inputs: Onboarding_V1_Hook_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lass dein Geld automatisch wachsen.`)
};

const pt_br2_onboarding_v1_hook_heading = /** @type {(inputs: Onboarding_V1_Hook_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça seu dinheiro crescer no piloto automático.`)
};

const tr_onboarding_v1_hook_heading = /** @type {(inputs: Onboarding_V1_Hook_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paranız otomatik olarak büyüsün.`)
};

const zh_cn2_onboarding_v1_hook_heading = /** @type {(inputs: Onboarding_V1_Hook_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让财富自动增长。`)
};

const zh_hk2_onboarding_v1_hook_heading = /** @type {(inputs: Onboarding_V1_Hook_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`讓財富自動增長。`)
};

const ko_kr2_onboarding_v1_hook_heading = /** @type {(inputs: Onboarding_V1_Hook_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 돈을 자동으로 키워보세요.`)
};

const ru_ru2_onboarding_v1_hook_heading = /** @type {(inputs: Onboarding_V1_Hook_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пусть ваши деньги растут автоматически.`)
};

const es_419_onboarding_v1_hook_heading = /** @type {(inputs: Onboarding_V1_Hook_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz crecer tu dinero en piloto automático.`)
};

/**
* | output |
* | --- |
* | "Grow your money on autopilot." |
*
* @param {Onboarding_V1_Hook_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_hook_heading = /** @type {((inputs?: Onboarding_V1_Hook_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Hook_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_hook_heading(inputs)
	if (locale === "de") return de_onboarding_v1_hook_heading(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_hook_heading(inputs)
	if (locale === "tr") return tr_onboarding_v1_hook_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_hook_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_hook_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_hook_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_hook_heading(inputs)
	return es_419_onboarding_v1_hook_heading(inputs)
});